import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

export const getIsUserAuthenticatedApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getIsUserAuthenticated: builder.query<boolean, void>({
            query: () => ({
                url: apiUserLink.users.info,
                method: "GET"
            }),
            transformResponse: (response: {is_authenticated: boolean}) => {
                return response.is_authenticated;
            },
            transformErrorResponse: (response) => {
                // Silence errors during authentication check (401, 404, network errors, etc.)
                return getIgnoredNotifyResponse(response, [401, 404, "FETCH_ERROR", "TIMEOUT_ERROR"]);
            }
        })
    }),
    overrideExisting: false
});
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

export const getIsUserAuthenticatedApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getIsUserAuthenticated: builder.query<boolean, void>({
            query: () => ({
                url: apiUserLink.users.info,
                method: "GET"
            }),
            transformResponse: (response: {is_authenticated: boolean}) => {
                return response.is_authenticated;
            },
            transformErrorResponse: (response) => {
                // Silence errors during authentication check (401, 404, network errors, etc.)
                return getIgnoredNotifyResponse(response, [401, 404, "FETCH_ERROR", "TIMEOUT_ERROR"]);
            }
        })
    }),
    overrideExisting: false
});
